import React, { useEffect, useRef, useState } from 'react';
import './custom-pagination.css';

/* ============ ICONS ============ */
const ChevronDoubleLeft = () => (
  <svg className="cpm__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 17L6 12L11 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 17L13 12L18 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronLeft = () => (
  <svg className="cpm__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronRight = () => (
  <svg className="cpm__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronDoubleRight = () => (
  <svg className="cpm__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 7L18 12L13 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 7L11 12L6 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronDown = () => (
  <svg className="cpm__select-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ============ PER PAGE DROPDOWN ============ */
const PerPageDropdown = ({ value, options, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="cpm__perpage" ref={ref}>
      <button
        type="button"
        className="cpm__select"
        onClick={() => setOpen(!open)}
        aria-label={`${value} на странице`}
        aria-expanded={open}
        tabIndex={0}
      >
        <span className="cpm__select-value">{value}</span>
        <span className="cpm__select-text"> на странице</span>
        <ChevronDown />
      </button>
      {open && (
        <div className="cpm__dropdown">
          {options.map((opt) => (
            <button
              key={opt}
              type="button"
              className={`cpm__option ${opt === value ? 'cpm__option--active' : ''}`}
              onClick={() => { onChange(opt); setOpen(false); }}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

/* ============ MAIN COMPONENT ============ */
const CustomPagination = ({
  currentPage,
  totalPages,
  totalItems,
  perPage,
  perPageOptions = [5, 10, 20, 50],
  onPageChange,
  onPerPageChange,
}) => {
  const rangeStart = totalItems === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const rangeEnd = Math.min(currentPage * perPage, totalItems);

  return (
    <div className="cpm">
      <p className="cpm__info">
        <span className="cpm__range">{rangeStart}-{rangeEnd}</span>
        <span className="cpm__text"> из </span>
        <span className="cpm__total">{totalItems}</span>
        <span className="cpm__text"> записей</span>
      </p>

      <div className="cpm__pages">
        <button type="button" className="cpm__btn" disabled={currentPage <= 1} onClick={() => onPageChange(1)} aria-label="Первая страница" tabIndex={0}>
          <ChevronDoubleLeft />
        </button>
        <button type="button" className="cpm__btn" disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)} aria-label="Предыдущая страница" tabIndex={0}>
          <ChevronLeft />
        </button>
        <div className="cpm__current">{currentPage}</div>
        <button type="button" className="cpm__btn" disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)} aria-label="Следующая страница" tabIndex={0}>
          <ChevronRight />
        </button>
        <button type="button" className="cpm__btn" disabled={currentPage >= totalPages} onClick={() => onPageChange(totalPages)} aria-label="Последняя страница" tabIndex={0}>
          <ChevronDoubleRight />
        </button>
      </div>

      <PerPageDropdown
        value={perPage}
        options={perPageOptions}
        onChange={onPerPageChange}
      />
    </div>
  );
};

export default CustomPagination;
